import { GitBranch } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { IconBadge } from '@/components/shared/IconBadge';

export function PluginDependenciesSection({ dependencies }: { dependencies: string[] }) {
  if (dependencies.length === 0) return null;

  return (
    <section data-testid="plugin-detail-section-dependencies">
      <IconSectionHeader icon={GitBranch}>Dependencies</IconSectionHeader>
      <div className="flex flex-wrap gap-2">
        {dependencies.map((dep) => (
          <IconBadge key={dep} icon={GitBranch}>
            {dep}
          </IconBadge>
        ))}
      </div>
    </section>
  );
}
